import React,{useState} from "react";
import {FaWhatsapp} from "@react-icons/all-files/fa/FaWhatsapp"
import {FiMail} from "@react-icons/all-files/fi/FiMail"
import {MdTextsms} from  "@react-icons/all-files/md/MdTextsms"



const ShareModal = ({message = ""})=>{

    const [copied, setCopied] = useState(false)

    const iconStyle = "bg-slate-100 p-3 rounded-full cursor-pointer"

    const openSMS = async()=>{
        const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        if(isMobile){
            window.open(`sms:?&body=${message}`);
        }else{
        }
      }

    const channels = [
        {   
            component: <FaWhatsapp size={60} className={iconStyle} onClick={()=>{window.open(`https://api.whatsapp.com/send?text=${message}`);}}/>,
            name:"Whatsapp"
        },

        {   
            component: <FiMail size={60} className={iconStyle} onClick={()=>{window.open(`mailto:?body=${message}&subject=Unete a Fiado con mi código de referido.`);}} />,
            name:"Correo"
        },
        {   
            component: <MdTextsms size={60} className={iconStyle} onClick={openSMS} />,
            name:"SMS"
        }
    ]

    return (<>
        
        <div  className='mb-3'>
            <div className='flex content-center items-center flex-row mb-5'>

                {channels.map((channel,index)=>(
                    <div className='flex content-center items-center flex-col w-4/12'>
                        {channel.component}
                        {channel.name}
                    </div>
                ))}

 
            </div>

            <div>
                <div className='p-4 bg-slate-100 rounded-lg mb-2'>
                    <div className='text-md'>{message}</div>
                </div>
                <div className='text-right cursor-pointer text-colorSecondary' onClick={(e)=>{e.preventDefault();  navigator.clipboard.writeText(message).then(()=>{setCopied(true)})}}>{copied == true ? 'Copiado...' : 'Copiar'}</div>
            </div>


        </div>

    </>)
}

export default ShareModal